import { render, staticRenderFns } from "./ChartIncidents.vue?vue&type=template&id=bef9d946&scoped=true"
import script from "./ChartIncidents.vue?vue&type=script&lang=js"
export * from "./ChartIncidents.vue?vue&type=script&lang=js"
import style0 from "./ChartIncidents.vue?vue&type=style&index=0&id=bef9d946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef9d946",
  null
  
)

export default component.exports